import api from "./api";

const testParameterService = {
  getAllTestParameters: (filters = {}) => {
    return api.get("/test-parameters", { params: filters });
  },

  getTestParameterById: (id) => {
    return api.get(`/test-parameters/${id}`);
  },

  createTestParameter: (parameterData) => {
    return api.post("/test-parameters", parameterData);
  },

  updateTestParameter: (id, parameterData) => {
    return api.put(`/test-parameters/${id}`, parameterData);
  },

  deleteTestParameter: (id) => {
    return api.delete(`/test-parameters/${id}`);
  },

  getByTest: (testId) => {
    // Prefer query-filter endpoint; avoids route-order pitfalls and matches other services.
    return api.get("/test-parameters", { params: { test_id: testId } });
  },
};

export default testParameterService;
